export default function handleFilePaste(e, composer) {
  // MS Word for Mac pastes an image file of the doc along with the HTML,
  // so bail out if we find HTML
  if (e.clipboardData?.getData('text/html')) {
    return false;
  }
  let handled = false;
  if (composer.config.upload && composer?.state) {
    let items = e.clipboardData?.items || e.clipboardData?.files;
    if (items && items.length > 0) {
      let allowedTypes = composer.config.upload.allowedImageFileTypes;
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let file = item.getAsFile();
        if (file && (allowedTypes.includes('*') || allowedTypes.includes(item.type))) {
          let from;
          let to;
          if (composer.state.selectionIsInTable || composer.state.selectionIsInNestedList || composer.state.selectionIsInCollapsibleSectionContent) {
            from = composer.state.prosemirrorState.selection.from;
            to = composer.state.prosemirrorState.selection.to;
          } else {
            from = composer.state.nearestInsertionPointToCursor;
            to = composer.state.nearestInsertionPointToCursor;
          }
          composer.commands.insertImageFileAtRange({
            from,
            to
          }, file);
          handled = true;
        }
      }
    }
  }
  return handled;
}